// extracted by mini-css-extract-plugin
export default {"container":"ZUzDnO2DkU3VR2WZjhc1"};